import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ContentService} from '../../../services';
import {Subscription} from 'rxjs/Subscription';
import {ContentDetails} from '../../../model/typings/content.types';
import {ImageAsset} from '../../../model/typings/asset.types';
import {ViewContent} from '../../../model/typings/view.types';
import {Meta, Title} from '@angular/platform-browser';
import {NavItem} from '../../../model/typings/nav.types';

@Component({
  selector: 'cpui-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  showInspiration = false;
  isLoading = false;
  homeNavState: string;
  viewContentLoaded = false;
  viewImageAssets: ImageAsset[];
  viewContent: ViewContent;
  backNavItem: NavItem;
  componentDetails: ContentDetails;
  productDetails: ContentDetails;
  userDetails: ContentDetails;
  interfaceDetails: ContentDetails;
  inspireDetails: ContentDetails;
  private viewRouteSubscription: Subscription;
  private viewContentSubscription: Subscription;
  private contentLoaderSubscription: Subscription;

  constructor(private metaService: Meta,
              private titleService: Title,
              private contentService: ContentService,
              private router: Router,
              private activeRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.resetViewMeta();
    this.getViewContent();

    this.contentLoaderSubscription = this.contentService.isLoadingObservable.subscribe((isLoading: boolean) => {
      this.isLoading = isLoading;
    });
    this.viewRouteSubscription = this.activeRoute.params.subscribe(params => this.onHomeRoute(params));
  }

  ngOnDestroy() {
    if (this.contentLoaderSubscription) {
      this.contentLoaderSubscription.unsubscribe();
    }
    if (this.viewRouteSubscription) {
      this.viewRouteSubscription.unsubscribe();
    }
    if (this.viewContentSubscription) {
      this.viewContentSubscription.unsubscribe();
    }
  }

  getViewContent() {
    this.viewContentSubscription = this.contentService.getContentForView({viewId: 'home', updateState: true})
      .subscribe((viewContent: ViewContent) => this.onViewContent(viewContent));
  }

  onHomeRoute(params) {
    const homeNavState = params['navState'];
    console.log(`CPUI - HomeComponent.onHomeRoute() homeNavState`, homeNavState);

    if (homeNavState) {
      this.showInspiration = (homeNavState === 'inspire');
      this.homeNavState = params['navState'] || '';
    }

    if (this.viewContent) {
      this.updateViewHeaderInfo(this.viewContent);
    }
  }

  onViewContent(viewContent: ViewContent) {
    console.log(`CPUI - HomeComponent.onViewContent()`, viewContent);
    this.viewContent = viewContent;

    this.backNavItem = (viewContent.navItemAncestry instanceof Array) ? viewContent.navItemAncestry[0] : null;

    if (this.viewContent.contentDetails) {
      this.viewContent.contentDetails.forEach(contentDetail => {
        const contentDetailsPrefix = 'contentDetails_home_';

        if (contentDetail.id === `${contentDetailsPrefix}component`) {
          this.componentDetails = contentDetail;
        } else if (contentDetail.id === `${contentDetailsPrefix}product`) {
          this.productDetails = contentDetail;
        } else if (contentDetail.id === `${contentDetailsPrefix}user`) {
          this.userDetails = contentDetail;
        } else if (contentDetail.id === `${contentDetailsPrefix}interface`) {
          this.interfaceDetails = contentDetail;
        } else if (contentDetail.id === `${contentDetailsPrefix}inspire`) {
          this.inspireDetails = contentDetail;
        }
      });
    }

    this.updateViewHeaderInfo(this.viewContent);
    this.viewImageAssets = this.viewContent.imageAssets;
    this.viewContentLoaded = true;
  }

  onLogoNavStateChange(navState): void {
    this.homeNavState = navState;
    const route = ['home', 'welcome'], routeWithNavState = ['home', navState];

    this.router.navigate(navState ? routeWithNavState : route);
  }

  onInspireChange() {
    const route = ['home', 'welcome'], inspireNavState = ['home', 'inspire'];
    this.router.navigate(this.showInspiration ? inspireNavState : route);
  }

  onInspirationVisibilityChange(showInspiration: boolean): void {
    this.showInspiration = showInspiration;
    this.onInspireChange();
  }

  showInspire(): void {
    this.showInspiration = true;
    this.onInspireChange();
  }

  setViewMeta(description: string, author: string): void {
    console.log(`CPUI - HomeComponent.setViewMeta()`, description, author);
    if (description) {
      this.metaService.addTag({name: 'description', content: description});
    }

    if (author) {
      this.metaService.addTag({name: 'author', content: author});
    }
  }

  resetViewMeta(): void {
    console.log(`CPUI - HomeComponent.resetViewMeta()`);
    const author = this.metaService.getTag('name=author');
    const description = this.metaService.getTag('name=description');
    this.metaService.removeTagElement(author);
    this.metaService.removeTagElement(description);
  }

  updateViewHeaderInfo(viewContent: ViewContent): void {
    console.log(`CPUI - HomeComponent.updateViewHeaderInfo()`, this.homeNavState);
    this.resetViewMeta();
    let {title, description, author} = viewContent;
    let activeContentDetail: ContentDetails;

    if (this.homeNavState === 'C' || this.homeNavState === 'component') {
      activeContentDetail = this.componentDetails;
    } else if (this.homeNavState === 'P' || this.homeNavState === 'product') {
      activeContentDetail = this.productDetails;
    } else if (this.homeNavState === 'U' || this.homeNavState === 'user') {
      activeContentDetail = this.userDetails;
    } else if (this.homeNavState === 'I' || this.homeNavState === 'interface') {
      activeContentDetail = this.interfaceDetails;
    } else if (this.homeNavState === 'inspire' && this.inspireDetails) {
      activeContentDetail = this.inspireDetails;
    }

    if (activeContentDetail) {
      title = `CPUI | ${activeContentDetail.title}`;
      description = activeContentDetail.description;
      author = activeContentDetail.author;
    }

    this.setViewMeta(description, author);
    this.titleService.setTitle(title);
  }

  isExpandedView(navState) {
    return (navState === 'component' || navState === 'product' || navState === 'user' || navState === 'interface');
  }

}



// WEBPACK FOOTER //
// ./src/app/components/views/home/home.component.ts